/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	var $window = $(window);
	var breakPoint = 1024;
	
	var resizeFlag = false;
	var windowWidth = $window.width();
	var windowHeight = $window.height();
	var _isFever = true;
	var _isOhmori = false;
	var _isFirst = false;
	
	//ローディング
	
	(0, _module.loading)();
	
	//ページ内リンクのアニメーション
	
	(0, _module.anchorScroll)();
	
	//SPヘッダーの開閉
	
	(0, _module.spHeaderToggle)();
	
	//YouTubeのモーダル
	
	(0, _module.youtubeModal)();
	
	//キービジュアル
	var kvAnimeFever = function kvAnimeFever(_time) {
	
	  var randomFever = Math.floor(Math.random() * Math.floor(2)) + 5;
	  // const randomFever = 6;
	  var $target = $('.idx-Keyvisual-' + randomFever);
	  // const $target = $('.idx-Keyvisual-' + 4);
	  $target.addClass('active');
	
	  var $active = $('.active');
	  setTimeout(function () {
	    if ($active.hasClass('idx-Keyvisual-5')) {
	      // ロゴ
	      $('#idx-Keyvisual_Logo_fever').velocity({ scale: [1, .1] }, { delay: 500, duration: 500, easing: 'easeOutBack', loop: false });
	      // キャラ
	      $('#idx-Keyvisual_Character-Vocal_fever').velocity({ opacity: [1, .0] }, { duration: 600, easing: 'linear', loop: false });
	    } else if ($active.hasClass('idx-Keyvisual-6')) {
	      if ($active.hasClass('idx-Keyvisual-6')) {
	        // ロゴ
	        $('#idx-Keyvisual_Logo_fever_02').velocity({ scale: [1, .1] }, { duration: 600, easing: 'easeOutBack', loop: false });
	        // キャラ
	        $('#idx-Keyvisual_Character-Popipa_fever').velocity({ scale: [1, .1] }, { duration: 600, easing: 'easeOutBack', loop: false });
	        $('#idx-Keyvisual_Character-Afterglow_fever').velocity({ scale: [1, .1] }, { duration: 600, easing: 'easeOutBack', loop: false });
	        $('#idx-Keyvisual_Character-Pasupare_fever').velocity({ scale: [1, .1] }, { duration: 600, easing: 'easeOutBack', loop: false });
	        $('#idx-Keyvisual_Character-Harohapi_fever').velocity({ scale: [1, .1] }, { duration: 600, easing: 'easeOutBack', loop: false });
	        $('#idx-Keyvisual_Character-Roselia_fever').velocity({ scale: [1, .1] }, { duration: 600, easing: 'easeOutBack', loop: false });
	        $('#idx-Keyvisual_Character-Ras_fever').velocity({ scale: [1, .1] }, { duration: 600, easing: 'easeOutBack', loop: false });
	        $('#idx-Keyvisual_Character-Morfonica_fever').velocity({ scale: [1, .1] }, { duration: 600, easing: 'easeOutBack', loop: false });
	      }
	    }
	  }, _time);
	  if ($active.hasClass('idx-Keyvisual-5')) {
	    setTimeout(function () {
	      $('#idx-Switch').addClass('active');
	    }, _time + 900);
	  } else if ($active.hasClass('idx-Keyvisual-6')) {
	    setTimeout(function () {
	      $('#idx-Switch').addClass('active');
	    }, _time + 600);
	  }
	};
	
	var kvAnimeOhmori = function kvAnimeOhmori(_time) {
	
	  var randomOhmori = Math.floor(Math.random() * Math.floor(2)) + 3;
	  var $target = $('.idx-Keyvisual-' + randomOhmori);
	  // const $target = $('.idx-Keyvisual-' + 4);
	  $target.addClass('active');
	
	  var $active = $('.active');
	  setTimeout(function () {
	    if ($active.hasClass('idx-Keyvisual-3')) {
	      // ロゴ
	      $('#idx-Keyvisual_Logo_ohmori').velocity({ scale: [1, .1] }, { duration: 600, easing: 'easeOutBack', loop: false });
	      // キャラ
	      $('#idx-Keyvisual_Character-Popipa_ohmori').velocity({ scale: [1, .1] }, { duration: 600, easing: 'easeOutBack', loop: false });
	      $('#idx-Keyvisual_Character-Afterglow_ohmori').velocity({ scale: [1, .1] }, { duration: 600, easing: 'easeOutBack', loop: false });
	      $('#idx-Keyvisual_Character-Pasupare_ohmori').velocity({ scale: [1, .1] }, { duration: 600, easing: 'easeOutBack', loop: false });
	      $('#idx-Keyvisual_Character-Harohapi_ohmori').velocity({ scale: [1, .1] }, { duration: 600, easing: 'easeOutBack', loop: false });
	      $('#idx-Keyvisual_Character-Roselia_ohmori').velocity({ scale: [1, .1] }, { duration: 600, easing: 'easeOutBack', loop: false });
	      $('#idx-Keyvisual_Character-Ras_ohmori').velocity({ scale: [1, .1] }, { duration: 600, easing: 'easeOutBack', loop: false });
	      $('#idx-Keyvisual_Character-Morfonica_ohmori').velocity({ scale: [1, .1] }, { duration: 600, easing: 'easeOutBack', loop: false });
	    } else if ($active.hasClass('idx-Keyvisual-4')) {
	      $active.addClass('animated');
	    }
	  }, _time);
	  if ($active.hasClass('idx-Keyvisual-3')) {
	    setTimeout(function () {
	      $('#idx-Switch').addClass('active');
	    }, _time + 600);
	  } else if ($active.hasClass('idx-Keyvisual-4')) {
	    setTimeout(function () {
	      $('#idx-Switch').addClass('active');
	    }, _time + 1800);
	  }
	};
	
	//キービジュアル第１期
	var kvAnimeFirst = function kvAnimeFirst(_time) {
	
	  var random = Math.floor(Math.random() * Math.floor(2)) + 1;
	  var $target = $('.idx-Keyvisual-' + random);
	  // const $target = $('.idx-Keyvisual-' + 4);
	  $target.addClass('active');
	
	  var $active = $('.active');
	  setTimeout(function () {
	    if ($active.hasClass('idx-Keyvisual-1')) {
	      // ロゴ
	      $('#idx-Keyvisual_Logo').velocity({ scale: [1, .1] }, { duration: 600, easing: 'easeOutBack', loop: false });
	      // キャラ
	      $('#idx-Keyvisual_Character-Popipa').velocity({ scale: [1, .1] }, { duration: 600, easing: 'easeOutBack', loop: false });
	      $('#idx-Keyvisual_Character-Afterglow').velocity({ scale: [1, .1] }, { duration: 600, easing: 'easeOutBack', loop: false });
	      $('#idx-Keyvisual_Character-Pasupare').velocity({ scale: [1, .1] }, { duration: 600, easing: 'easeOutBack', loop: false });
	      $('#idx-Keyvisual_Character-Harohapi').velocity({ scale: [1, .1] }, { duration: 600, easing: 'easeOutBack', loop: false });
	      $('#idx-Keyvisual_Character-Roselia').velocity({ scale: [1, .1] }, { duration: 600, easing: 'easeOutBack', loop: false });
	    } else if ($active.hasClass('idx-Keyvisual-2')) {
	      $active.addClass('animated');
	    }
	  }, _time);
	  if ($active.hasClass('idx-Keyvisual-1')) {
	    setTimeout(function () {
	      $('#idx-Switch').addClass('active');
	    }, _time + 600);
	  } else if ($active.hasClass('idx-Keyvisual-2')) {
	    setTimeout(function () {
	      $('#idx-Switch').addClass('active');
	    }, _time + 1800);
	  }
	};
	
	//切り替えボタン
	var kvSwitch = function kvSwitch() {
	  $('#idx-Switch').on('click', function () {
	    if (_isFever) {
	      $('.idx-Keyvisual').removeClass('active animated');
	      $('.idx-Keyvisual_Character_Item,.idx-Keyvisual_Logo_Item').velocity({ scale: [0, .1] }, { duration: 0, easing: 'linear', loop: false });
	      $('.idx-Keyvisual').velocity({ opacity: [1, .0] }, { duration: 600, easing: 'linear', loop: false });
	      kvAnimeOhmori(600);
	      $('#idx-Switch').removeClass().addClass('first');
	      _isFever = false;
	      _isOhmori = true;
	      _isFirst = false;
	    } else if (_isOhmori) {
	      $('.idx-Keyvisual').removeClass('active animated');
	      $('.idx-Keyvisual_Character_Item,.idx-Keyvisual_Logo_Item').velocity({ scale: [0, .1] }, { duration: 0, easing: 'linear', loop: false });
	      $('.idx-Keyvisual').velocity({ opacity: [1, .0] }, { duration: 600, easing: 'linear', loop: false });
	      kvAnimeFirst(600);
	      $('#idx-Switch').removeClass().addClass('fever');
	      _isFever = false;
	      _isOhmori = false;
	      _isFirst = true;
	    } else if (_isFirst) {
	      $('.idx-Keyvisual').removeClass('active animated');
	      // $('.idx-Keyvisual_Character_Item,.idx-Keyvisual_Logo_Item').velocity({ scale:[0,.1] }, { duration: 0, easing: 'linear', loop: false });
	      $('.idx-Keyvisual_Character-Vocal_fever').velocity({ opacity: 0 }, { duration: 0, easing: 'linear', loop: false });
	      kvAnimeFever(600);
	      $('#idx-Switch').removeClass().addClass('ohmori');
	      _isFever = true;
	      _isOhmori = false;
	      _isFirst = false;
	    }
	  });
	};
	
	window.addEventListener('load', function () {
	  kvAnimeFever(1600);
	  kvSwitch();
	});

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $window = $(window);
	// const breakPoint = 767;
	var breakPoint = 1199;
	
	var resizeFlag = false;
	var windowWidth = $window.width();
	var windowHeight = $window.height();
	//const bodyLimitHeight = (windowHeight - 185) * 0.88;
	
	var url = location.href;
	
	//ローディング
	var loading = function loading() {
	  var $target = $('#sw-Loading');
	  window.addEventListener('load', function () {
	    setTimeout(function () {
	      $target.fadeOut(600);
	    }, 1000);
	  });
	  setTimeout(function () {
	    $target.fadeOut(600);
	  }, 15000);
	};
	
	//ページ内リンクのアニメーション
	var anchorScroll = function anchorScroll() {
	  var $anchor = $('a[href^=#]');
	  $anchor.click(function () {
	    var speed = 1000;
	    var href = $(this).attr('href');
	    var target = $(href == '#' || href == '' ? 'html' : href);
	    var position = target.offset().top;
	    $('html, body').animate({
	      scrollTop: position
	    }, speed, 'swing');
	    return false;
	  });
	};
	
	//SPヘッダーの開閉
	var spHeaderToggle = function spHeaderToggle() {
	  //config
	  var $headerContent = $('#st-Header_Nav');
	  //open
	  var $headerOpen = $('#js-Header_Trigger');
	  $headerOpen.on('click', function () {
	    $headerContent.addClass('closed').addClass('opened');
	    return false;
	  });
	  //close
	  var $headerClose = $('#js-Header_Close');
	  $headerClose.on('click', function () {
	    $headerContent.removeClass('opened').addClass('closed');
	    return false;
	  });
	};
	
	//外部ページからのアンカー
	var externalAnchor = function externalAnchor() {
	  var url = $(location).attr('href');
	  if (url.indexOf("?id=") == -1) {} else {
	    var url_sp = url.split("?id=");
	    var hash = '#' + url_sp[url_sp.length - 1];
	    var tgt = $(hash);
	    var pos = void 0;
	    if (windowWidth > breakPoint) {
	      pos = tgt.offset().top - 177;
	    } else {
	      pos = tgt.offset().top - windowWidth * 0.24609375;
	    }
	    $("html, body").animate({
	      scrollTop: pos
	    }, 1000, "swing");
	  }
	};
	
	//YouTubeのモーダル
	var youtubeModal = function youtubeModal() {
	  var $modal = $('.sw-Movie');
	  var $content = $('.sw-Movie_Content');
	  var $youtube = $('.js-Youtube');
	  // open
	  $youtube.on('click', function () {
	    var dataID = $(this).attr('data-youtube');
	    //iframe append
	    $content.append('<iframe width="900" height="506" src="https://www.youtube.com/embed/' + dataID + '?rel=0&autoplay=1" frameborder="0"></iframe>');
	    // fadeIn
	    $modal.stop().fadeIn(400);
	    return false;
	  });
	  //close
	  $('.sw-Movie_Overlay,.sw-Movie_Close').on('click', function () {
	    $modal.stop().fadeOut(400, function () {
	      $content.children().remove();
	    });
	  });
	};
	
	//export
	exports.loading = loading;
	exports.anchorScroll = anchorScroll;
	exports.spHeaderToggle = spHeaderToggle;
	exports.externalAnchor = externalAnchor;
	exports.youtubeModal = youtubeModal;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index/app.bundle.js